import styled from "styled-components";
import tw from "twin.macro";

export const StyledCarousel = styled.div`
  max-width: 100vw;
  overflow: hidden;
  margin: 0 auto;
  position: relative;

  @media (min-width: 2400px) {
    max-width: 2400px;
  }

  .alice-carousel__wrapper {
    overflow: visible;

    ${({ theme }) => theme.media["lg"]} {
      padding-left: calc((100vw - 820px) / 2) !important;
      padding-right: calc((100vw - 820px) / 2) !important;
    }
    @media (min-width: 2400px) {
      padding-left: 820px !important;
      padding-right: 820px !important;
    }
  }
  .alice-carousel__stage-item {
    transition: all 0.2s ease;
    opacity: 0;

    ${({ theme }) => theme.media["lg"]} {
      transform: translateY(80px);
      opacity: 0.3;
      transition: all 0.2s linear;
    }
  }
  .__active:not(.__cloned) {
    transform: translateY(0);
    opacity: 1;
    transition: all 0.6s ease-out;
    ${({ theme }) => theme.media["lg"]} {
      transition: all 0.4s ease;
    }
  }
  .carousel-nav {
    ${tw`flex px-6 absolute justify-between`}
    position: absolute;
    top: 30px;
    width: 100%;
    justify-content: space-between;

    ${({ theme }) => theme.media["sm"]} {
      top: 45px;
    }

    ${({ theme }) => theme.media["md"]} {
      top: 50%;
      transform: translateY(-50%);
    }

    ${({ theme }) => theme.media["lg"]} {
      ${tw`relative justify-center`}
      height: 30px;
      margin-top: 100px;
      transform: unset;

      .nav-btn:first-child {
        ${tw`mr-6`}
      }
    }

    .nav-btn {
      color: #384e7f;
    }
  }
`;
